export default {
  amount: 'Сумма',
  creditScoring: 'Кредитный скоринг',
  grossProfit: 'Общая прибыль',
  totalRevenue: 'Общая выручка',
  entryPrice: 'Проходная цена',
  purchasePrice: 'Цена закупа',
  prices: 'Цены',
  ratio: 'Кратность',
};
